import React, { useState } from 'react';
import { Instagram, Facebook, Youtube, Twitter, Mail } from 'lucide-react';
import axios from 'axios';
import { BRAND } from '../mock/mock';
import { useToast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const { toast } = useToast();

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast({ title: 'Welcome to the Gaon Family', description: `We'll send tips, recipes and 10% off your first order to ${email}` });
      setEmail('');
    } catch {
      toast({ title: 'Could not subscribe', description: 'Please try again in a moment.' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer style={{ background: 'var(--gk-green)', color: '#e6dfc9' }}>
      {/* Newsletter */}
      <div className="border-b" style={{ borderColor: 'rgba(201,169,97,0.2)' }}>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="font-serif text-3xl font-bold mb-2" style={{ color: 'var(--gk-gold)' }}>Join the Gaon Family</h3>
            <p className="text-sm max-w-md">Subscribe for 10% off your first order, seasonal recipes and stories from the farms we work with.</p>
          </div>
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
            <div className="flex-1 flex items-center gap-2 px-4 py-3 rounded-full" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(201,169,97,0.4)' }}>
              <Mail size={16} style={{ color: 'var(--gk-gold)' }} />
              <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="your@email.com" className="flex-1 bg-transparent outline-none text-sm" style={{ color: '#fff' }} />
            </div>
            <button type="submit" disabled={busy} className="px-6 py-3 rounded-full font-semibold text-sm disabled:opacity-60" style={{ background: 'var(--gk-gold)', color: 'var(--gk-green-dark)' }}>{busy ? 'Subscribing...' : 'Subscribe'}</button>
          </form>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src={BRAND.logo} alt="logo" className="h-14 w-14 rounded-full ring-2 ring-[color:var(--gk-gold)]/60" />
            <div>
              <div className="font-serif text-lg font-bold" style={{ color: 'var(--gk-gold)' }}>GAON KE MASALE</div>
              <div className="text-[10px] tracking-[0.25em] uppercase opacity-75">Pure · Natural · Organic</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed opacity-85">Freshly ground spices and traditional blends from Indian villages, delivered to your kitchen with the honesty of a grandmother’s recipe.</p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Youtube, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors" style={{ border: '1px solid rgba(201,169,97,0.4)' }}>
                <Icon size={16} style={{ color: 'var(--gk-gold)' }} />
              </a>
            ))}
          </div>
        </div>

        {[
          { title: 'Shop', links: ['All Spices', 'Whole Spices', 'Ground Spices', 'Masala Blends', 'Gift Boxes', 'New Arrivals'] },
          { title: 'Learn', links: ['Recipes', 'Journal', 'Storage Tips', 'Our Farms', 'Wholesale'] },
          { title: 'Support', links: ['Contact Us', 'Shipping & Returns', 'FAQs', 'Track Order', 'Privacy Policy'] },
        ].map(col => (
          <div key={col.title}>
            <div className="font-serif text-lg font-bold mb-4" style={{ color: 'var(--gk-gold)' }}>{col.title}</div>
            <ul className="space-y-2 text-sm opacity-85">
              {col.links.map(l => <li key={l}><a href="#" className="link-underline">{l}</a></li>)}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t" style={{ borderColor: 'rgba(201,169,97,0.2)' }}>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between text-xs opacity-75 gap-2">
          <div>© {new Date().getFullYear()} Gaon Ke Masale. Made with care in India — www.gaonkemasale.com</div>
          <div className="flex gap-5">
            <a href="#">Terms</a>
            <a href="#">Privacy</a>
            <a href="#">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
